import React from "react";

export const QnADetailAvatarIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden>
    <path
      d="M8 8C9.65685 8 11 6.65685 11 5C11 3.34315 9.65685 2 8 2C6.34315 2 5 3.34315 5 5C5 6.65685 6.34315 8 8 8Z"
      stroke="#767676"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13 14C13 11.7909 10.7614 10 8 10C5.23858 10 3 11.7909 3 14"
      stroke="#767676"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const QnADetailDotsIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden>
    <path
      d="M10 10.8333C10.4602 10.8333 10.8333 10.4602 10.8333 10C10.8333 9.53976 10.4602 9.16667 10 9.16667C9.53976 9.16667 9.16667 9.53976 9.16667 10C9.16667 10.4602 9.53976 10.8333 10 10.8333Z"
      stroke="#767676"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 5.00001C10.4602 5.00001 10.8333 4.62691 10.8333 4.16667C10.8333 3.70644 10.4602 3.33334 10 3.33334C9.53976 3.33334 9.16667 3.70644 9.16667 4.16667C9.16667 4.62691 9.53976 5.00001 10 5.00001Z"
      stroke="#767676"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 16.6667C10.4602 16.6667 10.8333 16.2936 10.8333 15.8333C10.8333 15.3731 10.4602 15 10 15C9.53976 15 9.16667 15.3731 9.16667 15.8333C9.16667 16.2936 9.53976 16.6667 10 16.6667Z"
      stroke="#767676"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const QnADetailEditIcon = () => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" aria-hidden>
    <path
      d="M12.75 2.25L15.75 5.25M2.25 15.75H5.25L13.9875 7.0125L10.9875 4.0125L2.25 12.75V15.75Z"
      stroke="#222222"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const QnADetailDeleteIcon = () => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" aria-hidden>
    <path
      d="M2.25 4.5H15.75M7.5 4.5V3C7.5 2.58579 7.83579 2.25 8.25 2.25H9.75C10.1642 2.25 10.5 2.58579 10.5 3V4.5M14.25 4.5V15C14.25 15.4142 13.9142 15.75 13.5 15.75H4.5C4.08579 15.75 3.75 15.4142 3.75 15V4.5"
      stroke="#C94A4A"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const QnADetailMobileCloseIcon = () => (
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" aria-hidden>
    <path
      d="M9 3L3 9M3 3L9 9"
      stroke="#222222"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
